import { Nullable } from "models/Nullable";

import { isEmpty } from "./isEmpty";

export function sortAlphabetically<T extends string>(a: Nullable<T> | undefined, b: Nullable<T> | undefined) {
    if (isEmpty(a) && isEmpty(b)) {
        return 0
    }
    if (isEmpty(a)) {
        return -1
    }
    if (isEmpty(b)) {
        return 1
    }
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
}
